import Axios from "axios"
import queryString from 'query-string'
import jwt_decode from 'jwt-decode'

export const classNames = ( ...classes ) => {
    return classes.filter( Boolean ).join( "" )
}

export const truncate = ( str, n ) => ( str.length > n ) ? str.substr( 0, n - 1 ) + '...' : str

export const formatPhoneNumber = phone => {
    if( phone ) 
        return phone.split( " " ).join( "" )
}

export const capitalize = str => {
    if( str ) { 
        return str.slice( 0 , 1 )?.toUpperCase() + "" + str.slice( 1 )?.toLowerCase()
    }
    return str
}

export const formatCurrency = amount => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'UGX',
    } );
    return formatter.format( amount );
}

export const formatValues = value => {
    return value.toLocaleString( "en-US" )
}

export const createReferenceID = ( length, tag = true ) => {
    let chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return tag ? result?.toUpperCase() : result;
}

export const computeApplicationProgress = async ( id, form, callback ) => {
    try {
      const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/fetchAccessRecords`, {
          application_id: id,
          form
      } )
      if( response.data ){
        // console.log( response.data );
        // callback( {
        //     vetting_progress: response.data.length > 0 ?  response.data.map( val => val.vetting_tracker ).reduce( ( a, b ) => Math.max( a, b ) ) : 0,
        //     top_progress: response.data.length > 0 ?  response.data.map( val => val.progress ).reduce( ( a, b ) => Math.max( a, b ) ) : 0,
        //     stage: response.data.length > 0 ? response.data.map( item => item.stage ).reduce( ( a, b ) => Math.max( a, b ) ) : 0,
        //     organisations: response.data.map( val => val.organisation )
        //   } )
      }

    } catch( error ){
    }
}

export const convertFileToBase = ( selectedFile, successCallback ) => {
    if( selectedFile.length > 0 ) {
        let fileToLoad = selectedFile[ 0 ]
        let fileReader = new FileReader()
        let base64 

        fileReader.onload = function( fileLoadedEvt ) {
            base64 = fileLoadedEvt.target.result 
            successCallback( base64 )
        }
        fileReader.readAsDataURL( fileToLoad )
    }
}

export const handleFileChange = (e, tag, callback) => {
    e.persist()
    if( e.target?.files.length > 0 ){
      convertFileToBase(  e.target.files, result => {
        callback( result, e.target.files[ 0 ] )
      })
    }
    else {
      alert('File may not be attached correctly or of the correct format. Only pdf files are allowed to be attached')
    }
}


export const fetchUGhubToken = async ( successCallback, errorCallback ) => {
    try {
      const response = await Axios.get( `https://auth.cert.works.go.ug/api/getToken` )
      if( response.data ) {
        successCallback( response.data )
      }
    } catch (error) {
      errorCallback( error )
    }
}

export const fetchJsonToken = async ( successCallback, errorCallback ) => {
    try {
      const response = await Axios.get( `https://auth.cert.works.go.ug/api/getJWT` )
      if( response.data ) {
        let { jsontoken } = response.data 
        // setJsonToken( jsontoken )
        if( jsontoken ) {
          successCallback( jsontoken )
        }
      }
    } catch (error) {
      errorCallback( error )
    }
}

export const handleAuthorize = async ( code, ughubToken, json, successCallback, errorCallback ) => {

    if( ughubToken && json ){
      // let code = await localStorage.getItem( "code" )
      let url = `https://auth.cert.works.go.ug/api`
      const clientID = `QDzNG5kgvrtQ7PjeWezEN845w66cr0ty68TjI1xGF5aewhbU`
      const redirectUrl = `https://cert.works.go.ug`
      const clientAssertionType = "urn:ietf:params:oauth:client-assertion-type:jwtbearer"

      const payload = {
        grant_type: "authorization_code",
        Code: code,
        redirect_uri: redirectUrl,
        client_id: clientID,
        client_assertion_type: clientAssertionType,
        client_assertion: json
      }

      console.log( "payload", payload )
      console.log( "hub token", ughubToken )
      
      if( code ) {
      try {
        const response = await Axios.post( `${url}/ugpass_access_token`, {
          params: queryString.stringify( payload ),
          token: ughubToken
        }  ) 

        if( response?.data ) {
          successCallback( response?.data )
        }
      } catch (error) {
        errorCallback( error )
      }
    } 
    else {
      alert( "There is no code" )
    }

    }
}

export const getUserInfo = async ( data, callback ) => {
    if( data ) {
     const decoded  = jwt_decode( data?.id_token  );
    //  setUserInfo( decoded )
    callback( decoded )
    }
}